<template>
  <ModelsBody/>
</template>

<script>
// @ is an alias to /src
import ModelsBody from '@/components/ModelsBody.vue'

export default {
  name: 'ModelsView',
  components: {
    ModelsBody
  }
}
</script>
